
import { defineComponent } from 'vue'

import debounceDirective from '~/utils/directives/debounce'

export default defineComponent({
  name: 'ZToggle',
  directives: {
    debounce: debounceDirective
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean
    },
    debounceDelay: {
      default: 350,
      type: Number
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  methods: {
    toggle(newValue: boolean) {
      if (!this.disabled) this.$emit('input', newValue)
    },
    updateDebounce() {
      if (!this.disabled) this.$emit('debounce-click', !this.value)
    }
  }
})
